// extracted by mini-css-extract-plugin
module.exports = {"popoverTrigger":"Popover_popoverTrigger__iv2m1","arrow":"Popover_arrow__DLp_k","popover":"Popover_popover__NH5C_","popoverArrow":"Popover_popoverArrow__j4wHQ"};